__turbopack_context__.v({
  "footer": "footer-module-scss-module__yUv0PG__footer",
  "footerBottomLeft": "footer-module-scss-module__yUv0PG__footerBottomLeft",
  "footerBottomRight": "footer-module-scss-module__yUv0PG__footerBottomRight",
  "footerColumnHeading": "footer-module-scss-module__yUv0PG__footerColumnHeading",
  "footerColumnLink": "footer-module-scss-module__yUv0PG__footerColumnLink",
  "footerColumnList": "footer-module-scss-module__yUv0PG__footerColumnList",
  "footerLink": "footer-module-scss-module__yUv0PG__footerLink",
});
